import { render, staticRenderFns } from "./PiezaDental.vue?vue&type=template&id=4a194cb9"
import script from "./PiezaDental.vue?vue&type=script&lang=js"
export * from "./PiezaDental.vue?vue&type=script&lang=js"
import style0 from "./PiezaDental.vue?vue&type=style&index=0&id=4a194cb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports